import { Helmet } from "react-helmet-async"
import { IHotel } from "../../../../Hotels"
import { HotelAddOns } from "../../../../HotelAddOns"
import { useOutletContext } from "../../../../router-utils"

export default function HotelAddOnsPage() {
	const { hotel, revalidate } = useOutletContext<{
		hotel: IHotel
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Extra Services | Hotel</title>
			</Helmet>
			<HotelAddOns hotel={hotel} onChange={revalidate} />
		</>
	)
}
